import {includes, isNumber, toNumber} from "lodash";
import MarketRepository from "../features/Main/repository/MarketRepository";
import MarketSettingLocalStorage from "../features/Main/interface/MarketSettingLocalStorage";
import pwaStatus from "./pwaStatus";

export default function ValidateGetParams(
    key: keyof MarketSettingLocalStorage,
    value: string
) {
    if (!value) return;

    let isValid = false;
    const {isMobile} = pwaStatus()

    switch (key) {
        case "marketMode":
            const marketModeValues: MarketSettingLocalStorage["marketMode"][] = [
                "pos",
                "cash",
                "no-payment",
                "price-without-purchase",
                "view-only",
                "pos-or-cash",
            ];
            isValid = includes(marketModeValues, value);
            break;

        case "paymentMode":
            const paymentModeValues: MarketSettingLocalStorage["paymentMode"][] = [
                "pos",
                "cash",
                "no-payment",
            ];
            isValid = includes(paymentModeValues, value);
            break;

        case "themeMode":
            const themeModeValues = ["light", "dark"];
            isValid = includes(themeModeValues, value);
            break;

        case "basicReceiptInvoice":
        case "receipt":
            const numValue = toNumber(value);
            isValid = isNumber(numValue) && !isNaN(numValue);
            break;

        case "grid":
            const gridValue = String(value).trim();
            const regex = isMobile ? /^[1-3]$/ : /^[1-5]$/;
            isValid = regex.test(gridValue);
            break;

        case "color":
            const colorNum = toNumber(value);
            if (colorNum > 16) return;
            isValid = isNumber(colorNum) && !isNaN(colorNum);
            break;

        case "customBuy":
            isValid = value === "true" || value === "false";
            if (isValid) {
                MarketRepository.setSettingMarket(key, value === "true");
                return;
            }
            break;

        case "setting":
            isValid = value === "true" || value === "false";
            if (isValid) {
                MarketRepository.setSettingMarket(key, value === "true");
                return;
            }
            break;

        default:
            return;
    }

    if (isValid) {
        MarketRepository.setSettingMarket(key, value);
    }
}